import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { createEffect } from '@ngrx/effects';
import { GetJourneyStepsRequestAction, GetJourneyStepsResponseAction } from './common.actions';
import { EMPTY } from 'rxjs';
import { JourneyService } from 'src/app/services/journey.service';

@Injectable()
export class CommonEffects {
  constructor(private actions$: Actions,
    private journeyService: JourneyService) {
  }

  getJourney$ = createEffect(() => this.actions$.pipe(
    ofType(GetJourneyStepsRequestAction),
    switchMap((_action: any) => this.journeyService.getLatestJourney().pipe(
      map((data: any) => {
        return GetJourneyStepsResponseAction({ journey: data.data });
      }),
      catchError(err => {
        return EMPTY;
      })
    )),
  ));
}